import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { ShippingLine } from '../models/shippingLines/shippingLine';
import { PageOption } from '../models/common/pageOption';
import { KeyValuePair } from '../models/common/keyValuePair';
import { ShippingLineFilter } from '../models/shippingLines/shippingLineFilter';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';
import { of } from 'rxjs/observable/of';
import { CacheService } from './cache.service';
import { environment } from '../../environments/environment';
import { RequestResult } from '../models/common/requestResult';
import { PageOptionResult } from '../models/common/pageOptionResult';

@Injectable()
export class ShippingLineService {

	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getShippingLine(id: string): Observable<ShippingLine> {
		return this._http.get<ShippingLine>(`${this.origin}/api/shippinglines/${id}`)
			.pipe(
				tap(x => this.log(`getShippingLine: id=${id}`)),
				catchError(this._logService.handleError<ShippingLine>('getShippingLine'))
			);
	}

	getShippingLinesList(filter: PageOption<ShippingLineFilter>): Observable<PageOptionResult<ShippingLine>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<ShippingLine>>(`${this.origin}/api/shippinglines/${param}`)
			.pipe(
				tap(x => this.log(`getShippingLinesList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<ShippingLine>>('getShippingLinesList'))
			);
	}

	getShippingLinesDropdownList(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.shippingLineSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/menus/shippinglines`)
			.pipe(
				tap(x => {
					this.log(`getShippingLinesDropdownList`);
					if(x != undefined){
						this._cacheService.add(CACHE_KEYS.shippingLineSelection, x, 180);
					}
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getShippingLinesDropdownList'))
			);
	}

	addShippingLine(shippingline: ShippingLine): Observable<RequestResult<ShippingLine>> {
		this._cacheService.remove(CACHE_KEYS.shippingLineSelection);

		return this._http.post<RequestResult<ShippingLine>>(`${this.origin}/api/shippinglines`, JSON.stringify(shippingline))
			.pipe(
				tap(x => this.log(`addShippingLine: id=${shippingline.name}`)),
				catchError(this._logService.handleError<RequestResult<ShippingLine>>('addShippingLine'))
			);
	}

	updateShippingLine(shippingline: ShippingLine): Observable<RequestResult<ShippingLine>> {
		this._cacheService.remove(CACHE_KEYS.shippingLineSelection);
		
		return this._http.put<RequestResult<ShippingLine>>(`${this.origin}/api/shippinglines/${shippingline.id}`, JSON.stringify(shippingline))
			.pipe(
				tap(x => this.log(`updateShippingLine: id=${shippingline.id}`)),
				catchError(this._logService.handleError<RequestResult<ShippingLine>>('updateShippingLine'))
			);
	}

	copy(source: ShippingLine): ShippingLine {
		if(source === undefined || source === null){
			return null;
		}
		let copy = new ShippingLine();
		copy.id = source.id;
		copy.name = source.name;
		copy.createdBy = source.createdBy;
		copy.createdDate = source.createdDate;
		copy.updatedBy = source.updatedBy;
		copy.updatedDate = source.updatedDate;
		return copy;
	}

	private log(message: string) {
		this._messagesService.add('ShippingLineService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/shipping-line.service.ts